import { Form } from './types/form.type';
import { FormContext, FormData } from './types';
import { getPaymentMethodId } from './get-payment-method-id.util';

type Input = { form: Form | FormContext; formData: FormData };

export function getPaymentMethod({ form, formData }: Input) {
    return formData[getPaymentMethodId(form)];
}
